/*=========================================================================================
  File Name: moduleCountry.js
  Description: Country Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleServiceProviderSubscriptionState.js'
import mutations from './moduleServiceProviderSubscriptionMutations.js'
import actions from './moduleServiceProviderSubscriptionActions.js'
import getters from './moduleServiceProviderSubscriptionGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
